import { render, staticRenderFns } from "./product-list-card.vue?vue&type=template&id=c853b738&scoped=true&"
import script from "./product-list-card.vue?vue&type=script&lang=js&"
export * from "./product-list-card.vue?vue&type=script&lang=js&"
import style0 from "./product-list-card.vue?vue&type=style&index=0&id=c853b738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c853b738",
  null
  
)

export default component.exports